import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";

import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function AddProductScreenViewModel(logout, addSnackbar, onNavigate) {
  const [loading, setLoading] = useState(false);

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCategoryTypes = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("categoriesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setCategoryOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch category types");
    }
  };

  const getSubcategories = async function (categoryId) {
    if (!categoryId || categoryId < 1) {
      setSubcategoryOptions([]);
      return;
    }

    setLoading(true);
    let callResult = await makeGetApiCall(`subcategoriesForDropdown/${categoryId}`);
    setLoading(false);
    if (callResult.success) {
      setSubcategoryOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch subcategories");
    }
  };

  const createProduct = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall(
      "products/create",
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Product added",
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      onNavigate(`/products/${callResult.data.id}`);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Please make sure all required fields are filled.");
    }
  };

  return {
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    categoryOptions,
    getCategoryTypes,
    getSubcategories,
    createProduct,
    subcategoryOptions,
  };
}
